import script from "./Waveform.vue?vue&type=script&setup=true&lang=ts"
export * from "./Waveform.vue?vue&type=script&setup=true&lang=ts"

import "./Waveform.vue?vue&type=style&index=0&id=75c5740a&lang=scss"

const __exports__ = script;

export default __exports__